import { type AxiosResponse } from 'axios';

import { BaseError } from './base.error';

type HttpClientErrorArgs<T = unknown> = {
  context?: Record<string, unknown>;
  message: string;
  response?: AxiosResponse<T>;
  status?: number;
};

export class HttpClientError<T = unknown> extends BaseError {
  public readonly response?: AxiosResponse<T>;
  public readonly status: number;
  public readonly body: T | null;

  constructor({ context, message, response, status }: HttpClientErrorArgs<T>) {
    super(message, context);
    this.name = 'HttpClientError';
    this.response = response;
    this.status = status || 500;
    this.body = response?.data ?? null;
  }
}
